import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["message", "side", "author", "withRejectedMessage", "rejectedMessage", "stage", "withAvatar", "className", "reply", "withUsername"];
import React, { forwardRef } from 'react';
import { Avatar } from '@carnica/ui-kit';
import { combineRefs } from '@carnica/utils';
import { motion } from 'framer-motion';
import { cnBem } from "../../../../shared/lib";
import { useContextPosition, useMessageMenu } from "../../lib";
import { MessagePropStage } from "../../../../entities/message/types";
import { useAppSelector } from "../../../../shared/model";
import { selectContext } from "../../../../entities/message/model";
import { Menu } from "../../../../shared/ui";
import { MessageType } from "../../../../shared/api";
import styles from "./styles.pcss";
import { MessageContent } from "../MessageContent";
import { getAvatarSettings } from "./utils";
var cnMessage = cnBem('message', styles);
export var Message = /*#__PURE__*/forwardRef(function (props, ref) {
  var message = props.message,
    _props$side = props.side,
    side = _props$side === void 0 ? 'main' : _props$side,
    author = props.author,
    withRejectedMessage = props.withRejectedMessage,
    rejectedMessage = props.rejectedMessage,
    _props$stage = props.stage,
    stage = _props$stage === void 0 ? MessagePropStage.REJECTED : _props$stage,
    withAvatar = props.withAvatar,
    className = props.className,
    reply = props.reply,
    withUsername = props.withUsername,
    otherProps = _objectWithoutProperties(props, _excluded);
  var isAvatarVisible = side === 'opposite' && withAvatar;
  var hasLeftOffset = side === 'opposite' && !withAvatar;
  var menus = useMessageMenu(message, stage);
  var context = useAppSelector(selectContext);
  var contexted = (context === null || context === void 0 ? void 0 : context.id) === message.messageId;
  var _useContextPosition = useContextPosition(contexted, context, side),
    messageRef = _useContextPosition.messageRef,
    transform = _useContextPosition.transform,
    menuRef = _useContextPosition.menuRef,
    menuOffset = _useContextPosition.menuOffset,
    wrapperRef = _useContextPosition.wrapperRef;

  // Флаг для добавления псевдоэлемента
  var isTextMessage = message.message.type !== MessageType.Img;
  var avatarSettings = getAvatarSettings(author);
  return /*#__PURE__*/React.createElement(motion.div, _extends({
    animate: {
      y: transform,
      zIndex: contexted ? 3 : 0,
      pointerEvents: contexted ? 'none' : 'all'
    },
    className: cnMessage({
      side: side,
      leftOffset: hasLeftOffset
    }, [className]),
    ref: combineRefs([ref, messageRef]),
    transition: {
      y: {
        duration: 0.2
      }
    }
  }, otherProps), isAvatarVisible && /*#__PURE__*/React.createElement(Avatar, _extends({
    className: cnMessage('image', {
      view: avatarSettings.color || 'default'
    })
  }, avatarSettings)), /*#__PURE__*/React.createElement("div", {
    className: cnMessage('wrapper', {
      side: side,
      text: isTextMessage
    }),
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(MessageContent, {
    author: author,
    message: message,
    reply: reply,
    side: side,
    stage: stage,
    withUsername: withUsername
  })), contexted && context.reason && context.reason !== 'reply' && /*#__PURE__*/React.createElement("div", {
    className: cnMessage('container')
  }, /*#__PURE__*/React.createElement(Menu, {
    className: cnMessage('menu'),
    items: context.reason === 'error' ? menus.rejectMenu : menus.menu,
    ref: menuRef,
    style: _defineProperty(_defineProperty({}, '--offset-top', "".concat(menuOffset.top, "px")), '--offset-left', "".concat(menuOffset.left, "px")),
    theme: "dark",
    view: "default"
  })));
});